import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import RtoInfoRegNo from "./component";
import { setUserCarRegistrationNO } from "../car-registration-number/actions";

const mapStateToProps = ({
    rtoInfo: { pageType }
}) => ({
    pageType
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setUserCarRegistrationNOConnect: setUserCarRegistrationNO
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RtoInfoRegNo));
